<div id="customer-eligibility-completion">

  <div class="dividercomp section">
    <div class="row" id="action-divider"></div>
  </div>

  <div id="eligibility-completion">
    <div class="row">
      <div class="col-md-12">
        <div id="eligibility-completion-star" class="star">
          <div class="image" id="img">
            <img src="assets/images/star-large.png" alt="Star">
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="eligibility-completion-exclamation">
          <h1 style="display:none">Sonar Fix</h1>
          <h2><strong>{{cfetLabels.cfet_customer_eligibility.eligibility_completion}}</strong></h2>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="eligibility-completion-info">
          <h1 style="display:none">Sonar Fix</h1>
          <h2 id="info">{{cfetLabels.cfet_customer_eligibility.eligibility_completion_info}}</h2>
        </div>
      </div>
    </div>
  </div>

  <div class="row" id="eligibility-completion-footer-column1">
    <div class="col-md-12">
      <button type="button" id="btn-signup" (click)="signup($event)" (keyup)="signup($event)" tabindex="0"
        class="btn btn-alt btn-medium"><em aria-label=""></em>{{cfetButtonLabels.button_labels.signup}}</button>
    </div>
    <div class="col-md-12">
      <a (click)="cancelsignupCreation($event)" (keyup)="cancelsignupCreation($event)" tabindex="0" type="link"
        id="cancel_singup_link" class="btn btn-secondary btn-clear cancel_signup_link"><em aria-label=""></em>
        {{cfetButtonLabels.button_labels.cancel}}</a>
    </div>
  </div>
</div>